// extracted by mini-css-extract-plugin
export default {"section":"styles_section__g0dFQ","icon":"styles_icon__h5VZ2","heading":"styles_heading__bnSm2","para":"styles_para__QHLze","email":"styles_email__GF+6R"};